import React from "react";
import { Grid } from "@mui/material";
import InputContainer from "../../ui/layout/page/forms-container/form-item-container/input-container";
import RadioButtonContainer from "../../ui/layout/page/forms-container/form-item-container/radio-button-container/input-container";
import CompanyDepartment from "../shared/components/company-department";
import CompanyPosition from "../shared/components/company-position";
import Email from "../shared/components/email";
import FirstName from "../shared/components/first-name";
import Gender from "../shared/components/gender";
import Language from "../shared/components/language";
import LastName from "../shared/components/last-name";
import Phone from "../shared/components/phone";
import { PersonType } from "./types";

export type BasicAdditionalBenefitsFormProps = PersonType & {
  dataPath: string;
  isSameAsAdmin?: boolean;
  languages?: string[];
  companyDepartment: string;
  companyPosition: string;
  companyDataPath: string;
};

/**
 * Component that renders a form group to enter basic partner plus benefit data.
 * To be used only in a Formik render prop.
 */
export default function BasicAdditionalBenefitsForm({
  firstName,
  lastName,
  companyDepartment,
  companyPosition,
  companyDataPath,
  mobile,
  emailBusiness,
  dataPath = "",
  isSameAsAdmin = false,
  languages,
}: BasicAdditionalBenefitsFormProps): React.JSX.Element {
  return (
    <Grid
      className="scd-container-base"
      container
      size={{ xs: 12 }}
      key={dataPath}
    >
      <Gender dataPath={dataPath} />
      <InputContainer>
        <FirstName dataPath={dataPath} value={firstName} />
      </InputContainer>
      <InputContainer>
        <LastName dataPath={dataPath} value={lastName} />
      </InputContainer>
      <InputContainer>
        <CompanyDepartment
          value={companyDepartment}
          dataPath={companyDataPath}
        />
      </InputContainer>
      <InputContainer>
        <CompanyPosition value={companyPosition} dataPath={companyDataPath} />
      </InputContainer>
      <InputContainer>
        <Phone
          dataPath={dataPath}
          value={mobile}
          isMobile
          disabled={isSameAsAdmin}
        />
      </InputContainer>
      <InputContainer>
        <Email
          dataPath={dataPath}
          value={emailBusiness}
          isPrivate={false}
          disabled={isSameAsAdmin}
        />
      </InputContainer>
      <RadioButtonContainer>
        <Language languages={languages} dataPath={dataPath} />
      </RadioButtonContainer>
    </Grid>
  );
}
